import Blog from '@/components/Blog';
import Layout from '@/components/Layout';

Blog.getLayout = function getLayout(page) {
    return (
        <Layout webViewMobile={true} web='blog' >{page}</Layout>
    );
};

export async function getServerSideProps(context) {
    const UA = context.req.headers['user-agent'];
    const isMobile = Boolean(UA.match(
        /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i
    ));
    try {
        const res = await fetch(`${process.env.NEXT_PUBLIC_API_SERVER_URL || 'https://api.tcom-japan.com'}/app/blog/get-list-blog`,
        {
            headers: {
                'Content-Type': 'application/json',
                locale: context.locale

            }
        });
        const data = await res.json();

        if (!data || data.code !== 200) {
            return {
                notFound: true,
            };
        }

        return {
            props: { ...data.data, sign: context.locale },
        };
    } catch (error) {
        console.log(error);

        return {
            notFound: true,
        };
    }
}

export default Blog;